import { MouseEventHandler } from "react";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { Image } from "#shared/view/components/Image";
import { Paper } from "#shared/view/components/Paper";

export const Thumbnail = ({
  part,
  fallbackSrc = "/images/no-preview.png",
  size = { width: 55, height: 55 },
  cursor = "default",
  onClick = () => {},
}: {
  part?: PartDto;
  fallbackSrc?: string;
  size?: { width: number | string; height: number | string };
  cursor?: string;
  onClick?: MouseEventHandler<HTMLImageElement>;
}) => {
  const backgroundImage = part?.urlPng3D ?? part?.urlPng2D ?? fallbackSrc;

  if (!backgroundImage) {
    return <Paper mih={size.height} miw={size.width} radius="sm" withBorder />;
  }

  return (
    <Image
      style={{ cursor }}
      src={backgroundImage}
      h={size.height}
      w={size.width}
      radius="sm"
      fit="contain"
      bd="1px solid var(--mantine-color-gray-3)"
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
    />
  );
};
